import React, { useEffect } from "react";
import styles from "./../../styles/charts/chartStyle.module.css";
import { PieChart, PieChartLoading } from "./protoCharts/PieChart";
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Paper,
  Modal,
  Box,
  Typography,
} from "@mui/material";
import { useAllFundNames, useChallengeBudgetPerFunds } from "../../lib/hooks";
import { useState } from "react";
import {
  getChartBottomIcons,
  getChartInfoIcons,
} from "./twitter/TwitterWordCloud";
import { desc } from "../../lib/chartDescription";

const ChallengeFundsInFund = (props: any) => {
  const [fund, setFund] = React.useState<any>(5);

  const {
    allFundNames,
    loading: fundNameLoading,
    error: fundNameError,
  } = useAllFundNames();

  const { challengeAnalyticsData, loading, error } =
    useChallengeBudgetPerFunds(fund);

  useEffect(() => {
    !fundNameLoading &&
      fundNameError === null &&
      setFund(allFundNames.slice(-1)[0].fund_id);
    //eslint-disable-next-line
  }, [fundNameLoading]);

  let chartData: any[] = [];
  let labels: any[] = [];

  !loading &&
    error === null &&
    challengeAnalyticsData.forEach((item) => {
      chartData.push(item.challenge_amount);
      labels.push(item.challenge_name);
    });

  const handleChange = (event: any) => {
    setFund(event.target.value);
  };

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const content = (showMaxButton: boolean) => {
    return (
      <Paper elevation={3} className={styles.chartContainer}>
        <div className="horizontalCenter">
          <Typography className={styles.chartHeader}>
            {"Challenge Amounts in Fund" + fund}
          </Typography>
        </div>

        <div className="horizontalCenter">
          <div className={styles.selectOptionRow}>
            <FormControl
              sx={{
                m: 1,
                minWidth: 120,
                display: props.showSelect,
                width: "150px",
              }}
              size="small"
            >
              <InputLabel>Fund</InputLabel>
              <Select
                // style={{ fontSize: "14px" }}
                value={fund}
                label="Fund"
                onChange={handleChange}
                defaultValue=""
              >
                {allFundNames.map((fund: any) => (
                  <MenuItem
                    style={{ fontSize: "14px" }}
                    value={fund.fund_id}
                    key={fund.fund_id}
                  >
                    {fund.fund_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        <div style={{ width: "100%" }}>
          <>
            {loading && (
              <Box className={styles.center}>
                <PieChartLoading />
              </Box>
            )}
            {!loading && (
              <PieChart
                chartData={chartData}
                labels={labels}
                title={"Challenge Amounts in Fund" + fund}
              />
            )}
          </>
          {getChartBottomIcons(showMaxButton, setOpen)}
          {getChartInfoIcons(desc["fund"]["challengeAmount"])}
        </div>
      </Paper>
    );
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.fullScreenPieChart}>{content(false)}</Box>
      </Modal>
      {content(true)}
    </>
  );
};

export default ChallengeFundsInFund;
